<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import "./assets/js/remStyle.js"
export default {
  name: 'App'
}
</script>

<style>
  @import "./assets/css/reset.css";
</style>



// WEBPACK FOOTER //
// src/App.vue